const defaultState = {
    testing: false
};

export default function reducer(state = defaultState, action) {
    switch (action.type) {
        case 'GAMEKIT_OPEN_PLAYER': {
            return {
                ...state,
                testing: true
            };
        }
        case 'GAMEKIT_CLOSE_PLAYER': {
            return {
                ...state,
                testing: false
            };
        }
        case 'GAMEKIT_UPDATE_MM_SESSION_DATA' : {
            const { mmSessionId, mmApiUrl } = action;
            return {
                ...state,
                mmSessionId: mmSessionId,
                mmApiUrl: mmApiUrl
            };
        }
        default: {
            return state;
        }
    }
}
